import React from 'react'

 const NotFoundPage = () => {
    return (
        <>
            <h3>404: Page Not Found</h3>
        </>
    )
}
export default NotFoundPage